/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
 */
export interface GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'patternType': GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'storeType': GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'createdAt': string;
}

export const GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum = typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum[keyof typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum];
export const GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum = typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum[keyof typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum];


